import { TFeature } from '../../types/map';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EFeaturesActionType {
  FeaturePropertiesUpdated = 'features/propertiesUpdated',
}

export interface IFeaturePropertiesUpdateParameters {
  precision: number;
  featureId: TFeature['id'];
  properties: Partial<TFeature['properties']>;
}

export type TFeaturePropertiesUpdatedAction = ITypedReduxAction<
  EFeaturesActionType.FeaturePropertiesUpdated,
  IFeaturePropertiesUpdateParameters
>;

export type TFeaturesActions = TFeaturePropertiesUpdatedAction;
